export default class Progress {
  constructor(start, steps) {
    this._start = start;
    this._answers = new Map();
    this._current = start;
    this._stepsPriority = [];
    this._questionSet = new Set();
    this._pastQuestionSet = new Set();
    if (steps) {
      this.numberOfQuestion = steps;
    }
    this.goNext();
  }

  get current() {
    return this._current;
  }

  set stepsToStack(steps = []) {
    this._stepsPriority = (Array.isArray(steps)) ? [...steps, ...this._stepsPriority] : [steps, ...this._stepsPriority];
  }

  set stepsToTail(steps = []) {
    this._stepsPriority = (Array.isArray(steps)) ? [...this._stepsPriority, ...steps] : [...this._stepsPriority, steps];
  }

  get numberOfQuestion() {
    return this._questionSet.size;
  }

  set numberOfQuestion(steps) {
    for (const key in steps) {
      if (steps[key].type === 'simple-question') {
        this._questionSet.add(key);
      }
    }
  }

  get questionNumber() {
    return (this._pastQuestionSet.size > 9) ? `${this._pastQuestionSet.size}` : `0${this._pastQuestionSet.size}`;
  }

  startAgain() {
    this._pastQuestionSet = new Set();
    this._current = this._start;
    this.goNext();
  }

  cleanFromDoubled() {
    this._stepsPriority = Array.from(new Set(this._stepsPriority));
  }

  goNext() {
    this._current = (this._stepsPriority.length > 0) ? this._stepsPriority.shift() : this._current;
    if (this._questionSet.has(this._current)) {
      this._pastQuestionSet.add(this._current);
    }
  }
}



// WEBPACK FOOTER //
// ./moduls/progress.js